import {
  additionalInformationFields,
  attributionTrackingFields,
  dualRevenueFields,
  DYNAMIC_DATA_MAP,
  exclusivityFields,
  financialFields,
  projectInfoFields,
} from '../fields.config';

import { DealTypeKeys } from '../types';

export const sections = [
  { title: `Exclusivity & Position`, fields: exclusivityFields },
  {
    title: `Deal Information`,
    fields: (key: DealTypeKeys) => DYNAMIC_DATA_MAP[key],
  },
  { title: `Financial Information`, fields: financialFields },
  {
    title: `Financial Dual Revenue`,
    fields: dualRevenueFields,

    shouldShow: (type: DealTypeKeys) => type === 'CONTENT',
  },
  {
    title: `Attribution Tracking`,
    fields: attributionTrackingFields,
  },
  {
    title: `Project Information`,
    fields: projectInfoFields,

    shouldShow: (type: DealTypeKeys) => type === 'CONTENT',
  },
  {
    title: `Additional Information`,
    fields: additionalInformationFields,
  },
];
